import { gql } from '@apollo/client';

export const CONSUMER_GET_DOWNLOAD_URL = gql`
  query consumerGetS3ObjectSignedUrl($key: String!) {
    consumerGetS3ObjectSignedUrl(key: $key)
  }
`;